import { BOOK_PRICE } from "../../../utils/constants";

export default function QuantityStep({ qty, setQty }) {
  const buttonStyle = {
    width: 44,
    height: 44,
    border: "none",
    background: "transparent",
    fontSize: "20px",
    fontWeight: 400,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    color: "#1A1611",
    touchAction: "manipulation",
  };

  return (
    <div style={{ marginBottom: 40 }}>
      <h3
        style={{
          fontSize: "14px",
          textTransform: "uppercase",
          color: "#C4773B",
          marginBottom: 12,
        }}
      >
        Step 1 — How many copies?
      </h3>

      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          border: "1px solid rgba(26,22,17,0.15)",
          borderRadius: 4,
          overflow: "hidden",
        }}
      >
        <button
          type="button"
          aria-label="Decrease quantity"
          onClick={() => setQty(qty > 1 ? qty - 1 : 1)}
          style={{
            ...buttonStyle,
            borderRight: "1px solid rgba(26,22,17,0.12)",
          }}
        >
          −
        </button>

        <div
          style={{
            width: 52,
            height: 44,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Cormorant Garamond, serif",
            fontSize: "18px",
          }}
        >
          {qty}
        </div>

        <button
          type="button"
          aria-label="Increase quantity"
          onClick={() => setQty(qty + 1)}
          style={{
            ...buttonStyle,
            borderLeft: "1px solid rgba(26,22,17,0.12)",
          }}
        >
          +
        </button>
      </div>

      <p
        style={{
          fontSize: 14,
          color: "#000",
          marginTop: 10,
        }}
      >
        {qty} {qty === 1 ? "copy" : "copies"} — Ksh.{" "}
        {(qty * BOOK_PRICE).toLocaleString("en-KE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </p>
    </div>
  );
}